import { createFileRoute } from "@tanstack/react-router";
import { useTranslations } from "use-intl";

import { BannersPlacement } from "@/components/BannersPlacement/BannersPlacement";
import { HotelSearchForm } from "@/features/hotels/components/HotelSearchForm/HotelSearchForm";
import { useHotelSearchForm } from "@/features/hotels/hooks/useHotelSearchForm";
import type { HotelSearchFormValues } from "@/features/hotels/utils/hotelsValidation";
import { SearchCategorySwitcher } from "@/features/search/components/SearchCategorySwitcher";
import { BannersPlacementSlug } from "@/types/enums";

export const Route = createFileRoute("/_authenticated/hotels/search")({
  component: RouteComponent,
});

function RouteComponent() {
  const t = useTranslations();

  const navigate = Route.useNavigate();

  const { handleSubmit: handleHotelSearchFormSubmit } = useHotelSearchForm();

  const handleHotelSearchSubmit = (values: HotelSearchFormValues) => {
    handleHotelSearchFormSubmit(values);
    navigate({ to: "/hotels/list" });
  };

  return (
    <main className="w-full space-y-3 p-main">
      <SearchCategorySwitcher current="hotels" />

      <div className="rounded-4xl bg-surface-base-light p-4 shadow-md">
        <HotelSearchForm
          submitButtonContent={t("hotels.search.searchHotel")}
          onSubmit={handleHotelSearchSubmit}
          analyticsSource="main"
        />
      </div>

      <BannersPlacement slug={BannersPlacementSlug.HOTEL_PAGE_SLOT_1} />
      <BannersPlacement slug={BannersPlacementSlug.HOTEL_PAGE_SLOT_2} />
      <BannersPlacement slug={BannersPlacementSlug.HOTEL_PAGE_SLOT_3} />
    </main>
  );
}
